export class GAEventTypes {
  static DemoStart = 'DemoStart';
  static DemoSent = 'DemoSent';
  static PriceStart = 'PriceStart';
  static PriceSent = 'PriceSent';
  static ContactStart = 'ContactStart';
  static ContactSend = 'ContactSend';
}
